export default "<app-courier-list></app-courier-list>\n"